import React from 'react';

export interface LatestRiskToggle {
  latestRiskSelected: boolean;
  handleLatestRiskToggle: (event: any) => void;
}

/** Toggle state for the "Last Underwriting" ⟷ "Latest Risk" switch. */
export const useLatestRiskToggle = (): LatestRiskToggle => {
  const [latestRiskSelected, setLatestRiskSelected] = React.useState(false);

  const handleLatestRiskToggle = (event: any) => {
    setLatestRiskSelected(event.target.checked);
  };

  return { latestRiskSelected, handleLatestRiskToggle };
};

export default useLatestRiskToggle;
